import React,{useState} from 'react'
import CustomerForm from './CustomerForm';
import CustomerListview from './CustomerListview';

const Customers = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <CustomerForm addForm={setFromIsShown} update={upData} />
        ) : (
          <CustomerListview addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default Customers